import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/plm_appCommonService";
import hrItemService from "../../../services/customer_v2_appCommonService";
const initialState = {
  article: {
    data: [],
    status: true,
    articleNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  employee: {
    data: [],
    status: true,
    employeeNr: "",
    workflowEmp: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  task: {
    data: [],
    status: true,
    taskNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  atd: {
    data: [],
    status: true,
    atdNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  cashExpenses: {
    data: [],
    status: true,
    cashExpensesNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  client: {
    data: [],
    status: true,
    clientNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  project: {
    data: [],
    status: true,
    projectNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
  receipts: {
    data: [],
    status: true,
    receiptNr: "",
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
};

export const hrSlice = createSlice({
  name: "hr",
  initialState,
  reducers: {
    articleNr(state, action) {
      state.article.articleNr = action.payload;
    },
    employeeNr(state, action) {
      state.employee.employeeNr = action.payload;
    },
    workflowEmp(state, action) {
      state.employee.workflowEmp = action.payload;
    },
    addTaskNr(state, action) {
      state.task.taskNr = action.payload;
    },
    addAttendance(state, action) {
      state.atd.atdNr = action.payload;
    },
    cashExpensesNr(state, action) {
      state.cashExpenses.cashExpensesNr = action.payload;
    },
    clientNr(state, action) {
      state.client.clientNr = action.payload;
    },
    projectNr(state, action) {
      state.project.projectNr = action.payload;
    },
    receiptNr(state, action) {
      state.receipts.receiptNr = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getArticleList.pending, (state, action) => {
        state.article.status = true;
      })
      .addCase(getArticleList.fulfilled, (state, action) => {
        state.article.data = action.payload.data;
        state.article.pagination.page = action.payload.page;
        state.article.pagination.per_page = action.payload.per_page;
        state.article.pagination.total = action.payload.total;
        state.article.status = false;
      })
      .addCase(getEmployeeList.pending, (state, action) => {
        state.employee.status = true;
      })
      .addCase(getEmployeeList.fulfilled, (state, action) => {
        state.employee.data = action.payload.data;
        state.employee.pagination.page = action.payload.page;
        state.employee.pagination.per_page = action.payload.per_page;
        state.employee.pagination.total = action.payload.total;
        state.employee.status = false;
      })
      .addCase(getTaskList.pending, (state, action) => {
        state.task.status = true;
      })
      .addCase(getTaskList.fulfilled, (state, action) => {
        state.task.data = action.payload.data;
        state.task.pagination.page = action.payload.page;
        state.task.pagination.per_page = action.payload.per_page;
        state.task.pagination.total = action.payload.total;
        state.task.status = false;
      })
      .addCase(getCashExpenses.pending, (state, action) => {
        state.cashExpenses.status = true;
      })
      .addCase(getCashExpenses.fulfilled, (state, action) => {
        state.cashExpenses.data = action.payload.data;
        state.cashExpenses.pagination.page = action.payload.page;
        state.cashExpenses.pagination.per_page = action.payload.per_page;
        state.cashExpenses.pagination.total = action.payload.total;
        state.cashExpenses.status = false;
      })
      .addCase(getAtdList.pending, (state, action) => {
        state.atd.status = true;
      })
      .addCase(getAtdList.fulfilled, (state, action) => {
        state.atd.data = action.payload.data;
        state.atd.pagination.page = action.payload.page;
        state.atd.pagination.per_page = action.payload.per_page;
        state.atd.pagination.total = action.payload.total;
        state.atd.status = false;
      })
      .addCase(getClientList.pending, (state, action) => {
        state.client.status = true;
      })
      .addCase(getClientList.fulfilled, (state, action) => {
        state.client.data = action.payload.data;
        state.client.pagination.page = action.payload.page;
        state.client.pagination.per_page = action.payload.per_page;
        state.client.pagination.total = action.payload.total;
        state.client.status = false;
      })
      .addCase(getProjectList.pending, (state, action) => {
        state.project.status = true;
      })
      .addCase(getProjectList.fulfilled, (state, action) => {
        state.project.data = action.payload.data;
        state.project.pagination.page = action.payload.page;
        state.project.pagination.per_page = action.payload.per_page;
        state.project.pagination.total = action.payload.total;
        state.project.status = false;
      })
      .addCase(getReceiptsList.pending, (state, action) => {
        state.receipts.status = true;
      })
      .addCase(getReceiptsList.fulfilled, (state, action) => {
        state.receipts.data = action.payload.data;
        state.receipts.pagination.page = action.payload.page;
        state.receipts.pagination.per_page = action.payload.per_page;
        state.receipts.pagination.total = action.payload.total;
        state.receipts.status = false;
      });
  },
});

export const {
  articleNr,
  employeeNr,
  workflowEmp,
  addTaskNr,
  addAttendance,
  cashExpensesNr,
  clientNr,
  projectNr,
  receiptNr,
} = hrSlice.actions;

export const getArticleList = createAsyncThunk(
  "getArticleList",
  async (param) => {
    console.log(">> loaded getArticleList");
    const res = await ItemService.generatePlmQuery(param);
    return res;
  },
);

export const getEmployeeList = createAsyncThunk(
  "getEmployeeList",
  async (param) => {
    console.log(">> loaded getEmployeeList ");
    const res = await hrItemService.generateCustomerQuery(param);
    return res;
  },
);
export const getTaskList = createAsyncThunk("getTaskList", async (param) => {
  console.log(">> loaded getTaskList ");
  const res = await hrItemService.generateCustomerQuery(param);
  return res;
});
export const getAtdList = createAsyncThunk("getAtdList", async (param) => {
  console.log(">> loaded getAtdList ");
  const res = await hrItemService.generateCustomerQuery(param);
  return res;
});
export const getCashExpenses = createAsyncThunk(
  "getCashExpenses",
  async (param) => {
    console.log(">> loaded getCashExpenses ");
    const res = await hrItemService.generateCustomerQuery(param);
    return res;
  },
);
export const getClientList = createAsyncThunk(
  "getClientList",
  async (param) => {
    console.log(">> loaded getClientList ");
    const res = await hrItemService.generateCustomerQuery(param);
    return res;
  },
);
export const getProjectList = createAsyncThunk(
  "getProjectList",
  async (param) => {
    console.log(">> loaded getProjectList ");
    const res = await hrItemService.generateCustomerQuery(param);
    return res;
  },
);
export const getReceiptsList = createAsyncThunk(
  "getReceiptsList",
  async (param) => {
    console.log(">> loaded getReceiptsList ");
    const res = await hrItemService.generateCustomerQuery(param);
    return res;
  },
);

export default hrSlice.reducer;
